/* eslint-disable react/prop-types */
import clsx from "clsx";
import React, { FunctionComponent } from "react";

import { useSearchForm } from "../../stores/hooks/useSearchForm";
import { Tabs, tabVehicle } from "./Tabs";
import { TireSize } from "./TireSize";
import { Vehicle } from "./Vehicle";

type Props = {
  compact?: boolean;
};

export const SearchFormLanding: FunctionComponent<Props> = ({ compact }) => {
  const [{ activeTab }] = useSearchForm();
  return (
    <section
      className={clsx("tw-landing-form", compact && "tw-landing-form--compact")}
    >
      <Tabs className="mx-auto" compact={compact} />
      <div className="rounded-panel lg:rounded-button-group p-3 sm:p-6 lg:p-4">
        {activeTab === tabVehicle ? <Vehicle /> : <TireSize />}
      </div>
    </section>
  );
};
